module.exports = __webpack_public_path__ + "html/explainer_82bd99fa4330bb99d43a000775aa8258.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/explainer.html
// module id = v09R
// module chunks = 151